<template>
  <div>
    <logo-url :organisation="organisation"></logo-url>
    <br />
    <hr />
    <subject :organisation="organisation"></subject>
    <br />
    <hr />
    <email-text
      :organisation="organisation"
      header="Global email header"
      description="All outgoing client emails will contain this text at the top of the email."
      text-type="header"
      button-text="Save header"
    ></email-text>
    <br />
    <hr />
    <email-text
      :organisation="organisation"
      header="Global email footer"
      description="All outgoing client emails will contain this text at the bottom of the email."
      text-type="footer"
      button-text="Save footer"
    ></email-text>
  </div>
</template>

<script>
import EmailText from './email-text';
import LogoUrl from './logo';
import Subject from './subject';

export default {
  components: {
    EmailText,
    LogoUrl,
    Subject,
  },

  props: {
    organisation: Object,
  },
};
</script>

<style lang="scss" scoped=""></style>
